import styled from 'styled-components';
import { Link } from 'react-router-dom';
export var AppLinkStyling = styled(Link).withConfig({
  displayName: "AppLinkstyles__AppLinkStyling",
  componentId: "pantheon__sc-13q40a0-0"
})(["font-weight:700;text-decoration:none;color:#454545;"]);